import { INSURANCE_OPTIONS } from 'Common/constants/insuranceOptions';

export default class BenefitItemCtrl {
  constructor() {
    this.BENEFIT_TYPE = INSURANCE_OPTIONS.BENEFIT_TYPE;
  }
}
